export default __webpack_public_path__ + "static/media/7.3573dc5a.png";